import { render, staticRenderFns } from "./VItemCounter.vue?vue&type=template&id=0b4d9880&scoped=true&"
import script from "./VItemCounter.vue?vue&type=script&lang=js&"
export * from "./VItemCounter.vue?vue&type=script&lang=js&"
import style0 from "./VItemCounter.vue?vue&type=style&index=0&id=0b4d9880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d9880",
  null
  
)

export default component.exports